<template lang="pug">
  .lightbox
    .big-image.text-center
      img(:src="itemSelected.src")
    .galleries
      .galleries-list
        .galleries-item(v-for="item of items")
          img(:src="item.src" @click="selectItem(item)")
    a.close-lightbox(href="#" @click.prevent="onClose"): i.fa.fa-times
        

</template>

<script>
import $ from 'jquery'
import _ from 'lodash'

export default {
  data () {
    return {
      itemSelected: {},
      listWidth: 0
    }
  },

  props: {
    items: Array | null
  },

  methods: {
    selectItem (item) {
      this.itemSelected = item
    },

    onClose () {
      this.$emit('onClose')
    },

    countItem () {
      this.items.forEach(element => {
        this.listWidth += 100
      })
      $('.galleries-list').css({
        'minWidth': `${this.listWidth}px`
      })
    }
  },

  mounted () {
    if (this.items) this.itemSelected = _.cloneDeep(this.items[0])
    this.countItem()
    $('body').addClass('hasModal')
  },

  beforeDestroy () {
    $('body').removeClass('hasModal')
  }
}
</script>

<style lang="less" scoped>
.lightbox {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.35);
  z-index: 9998;
}

.big-image {
  height: 80vh;
  padding-top: 20px;

  img {
    max-height: 100%;
  }
}

.galleries {
  position: absolute;
  text-align: center;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  overflow-y: auto;
  padding: 10px 0;
  background-color: rgba(0, 0, 0, 0.35);

  .galleries-item {
    display: inline-block;
    width: 80px;
    height: 80px;
    overflow: hidden;
    margin: 0 10px;

    img {
      width: 100%;
    }
  }
}

.close-lightbox {
  position: absolute;
  top: 10px;
  right: 16px;
  font-size: 30px;
  color: white;
  z-index: 9998;
}
</style>





// WEBPACK FOOTER //
// LightboxGalleries.vue?481842a4